import React, { useEffect, useCallback } from 'react';
import { Link, useLocation } from 'react-router-dom';
import Cookie from 'universal-cookie';
import { decrypt } from './useCryptoJS';
import '../styles/navbar_styles.css';
import logo from '../images/logo.png';

const Navbar = React.memo((props) => {
  const cookies = new Cookie();
  const location = useLocation();

  const getDecryptedCookie = useCallback((key, defaultValue = "0000") => {
    try {
      const value = cookies.get(key);
      return value !== undefined ? decrypt(value) : defaultValue;
    } catch (error) {
      console.error(`Error decrypting cookie ${key}:`, error);
      return defaultValue;
    }
  }, []);

  const uruser = getDecryptedCookie('uruser');
  const uruserGroup = getDecryptedCookie('uruserGroup');
  const uruserDashboard = getDecryptedCookie('uruserDashboard');
  const uralarm = getDecryptedCookie('uralarm');
  const urview = getDecryptedCookie('urview');
  const ursource = getDecryptedCookie('ursource');
  const urreport = getDecryptedCookie('urreport', "0");
  const urrole = getDecryptedCookie('urrole', "00000");
  const userstatus = getDecryptedCookie('userStatus', "");

  const toggleDropdownIcon = useCallback((target) => {
    target.innerHTML = target.innerHTML === 'expand_more' ? 'expand_less' : 'expand_more';
  }, []);

  const toggleDropdownLinks = useCallback((children) => {
    children.forEach(child => {
      child.style.display = child.style.display === 'none' ? '' : 'none';
    });
  }, []);

  const toggleDropdown = useCallback((e) => {
    e.preventDefault();
    e.stopPropagation();
    const icon = e.target;
    toggleDropdownIcon(icon);
    // Find the parent navbar-dropdown-container to ensure correct context
    let dropdownContainer = icon.parentElement;
    while (dropdownContainer && !dropdownContainer.classList.contains('navbar-dropdown-container')) {
      dropdownContainer = dropdownContainer.parentElement;
    }
    if (dropdownContainer) {
      const dropdownChildren = Array.from(dropdownContainer.children)
        .filter(child => child.classList.contains('navbar-dropdown-item'));
      toggleDropdownLinks(dropdownChildren);
    }
  }, [toggleDropdownIcon, toggleDropdownLinks]);

  useEffect(() => {
    const timer = setTimeout(() => {
      const sideNavEl = document.querySelector('.js-side-nav');
      const sideNavContainerEl = document.querySelector('.js-side-nav-container');
      const showButtonEl = document.querySelector('.js-menu-open');
      const closeButtonEl = document.querySelector('.js-menu-close');
      const dropdowns = document.querySelectorAll('.navbar-dropdown-container');
      const dropdownIcons = document.querySelectorAll('.navbar-dropdown-icon');

      if (!sideNavContainerEl || !showButtonEl || !closeButtonEl) {
        console.warn('Navbar DOM elements not found');
        return;
      }

      const blockClicks = (evt) => evt.stopPropagation();

      const onTransitionEnd = () => {
        sideNavContainerEl.classList.remove('side-nav-animatable');
        sideNavContainerEl.removeEventListener('transitionend', onTransitionEnd);
      };

      const initialiseDropdowns = () => {
        dropdowns.forEach(dropdown => {
          Array.from(dropdown.children)
            .filter(child => child.classList.contains('navbar-dropdown-item'))
            .forEach(child => {
              child.style.display = "none";
            });
        });
      };

      const openSideNav = () => {
        sideNavContainerEl.classList.add('side-nav-animatable', 'side-nav-visible');
        sideNavContainerEl.addEventListener('transitionend', onTransitionEnd);
      };

      const closeSideNav = () => {
        sideNavContainerEl.classList.add('side-nav-animatable');
        sideNavContainerEl.classList.remove('side-nav-visible');
        sideNavContainerEl.addEventListener('transitionend', onTransitionEnd);
      };

      const addEventListeners = () => {
        showButtonEl.addEventListener('click', openSideNav);
        closeButtonEl.addEventListener('click', closeSideNav);
        sideNavEl?.addEventListener('click', blockClicks);
        sideNavContainerEl.addEventListener('click', closeSideNav);
        initialiseDropdowns();
        dropdownIcons.forEach(icon => icon.addEventListener('click', toggleDropdown));
      };

      addEventListeners();

      return () => {
        showButtonEl.removeEventListener('click', openSideNav);
        closeButtonEl.removeEventListener('click', closeSideNav);
        sideNavEl?.removeEventListener('click', blockClicks);
        sideNavContainerEl.removeEventListener('click', closeSideNav);
        dropdownIcons.forEach(icon => icon.removeEventListener('click', toggleDropdown));
      };
    }, 50);

    return () => clearTimeout(timer);
  }, [toggleDropdown]);

  const getLinkClass = (path) => {
    return location.pathname === path ? 'navbar-link active' : 'navbar-link';
  };

  return (
    <nav id="navbar">
      <div id="display-flex" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%', position: 'relative' }}>
        <div style={{ flexShrink: 0 }}>
          <a className="js-menu-open menu-open">
            <i className="material-icons">menu</i>
          </a>
        </div>
        <div id="main-logo-container" style={{ position: 'absolute', left: '50%', transform: 'translateX(-50%)', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <Link to="/dashboard" style={{ display: 'flex', alignItems: 'center', textDecoration: 'none', color: 'inherit' }}>
            <img src={logo} alt="Embedos Logo" id="mainLogo" style={{ width: "1.5rem", height: "1.5rem", marginRight: "0.7rem" }} />
            <h3 style={{ margin: 0 }}><strong>Embedos</strong></h3>
          </Link>
        </div>
        <div style={{ display:'flex', justifyContent:'center', alignItems:'center' }}>
          <a onClick={props.onToggleTopPanel} style={{ marginLeft: '0.5rem', cursor: 'pointer' }}>
            <i className="material-icons">settings</i>
          </a>
          <h5 className="dashboard-name"><span>Dashboard: {props.newDashboard || "None"}</span></h5>
           
        </div>
      </div>
      <div className="js-side-nav-container side-nav-container">
        <div className="js-side-nav side-nav">
          <a id="menu-close-icon-container" className="js-menu-close menu-close">
            <i className="material-icons">close</i>
          </a>
          <div className="navbar-link-container">
            <i className="material-icons navbar-icon">home</i>
            <Link to="/dashboard" className={`${getLinkClass('/dashboard')} js-menu-close menu-close`}>Home</Link>
          </div>
          <div className="navbar-link-container">
            <i className="material-icons navbar-icon">person</i>
            <Link to="/user-profile" className={`${getLinkClass('/user-profile')} js-menu-close menu-close`}>Profile</Link>
          </div>
          <div className="navbar-link-container">
            <i className="material-icons navbar-icon">notes</i>
            <Link to="/EventLog" className={`${getLinkClass('/EventLog')} js-menu-close menu-close`}>Log</Link>
          </div>
          {(uruser[0] === '1' || uruserGroup[0] === '1' || uruserDashboard[0] === '1') && (
            <div className="navbar-dropdown-container">
              <div className="navbar-dropdown-header">
                <i className="material-icons navbar-icon">manage_accounts</i>
                <Link to="/user_management" className={`${getLinkClass('/user_management')} js-menu-close menu-close`}>User Management</Link>
                <i className="material-icons navbar-dropdown-icon">expand_more</i>
              </div>
              {(uruser[0] === '1' || uruser[1] === '1') && (
                <div className="navbar-link-container navbar-dropdown-item">
                  <i className="material-icons navbar-icon">person</i>
                  <Link to="/user_management/users" className={`${getLinkClass('/user_management/users')} js-menu-close menu-close`}>Users</Link>
                </div>
              )}
              {(uruserGroup[0] === '1' || uruserGroup[1] === '1') && (
                <div className="navbar-link-container navbar-dropdown-item">
                  <i className="material-icons navbar-icon">people_alt</i>
                  <Link to="/user_management/user_groups" className={`${getLinkClass('/user_management/user_groups')} js-menu-close menu-close`}>User Groups</Link>
                </div>
              )}
              {(uruserDashboard[0] === '1' || uruserDashboard[1] === '1') && (
                <div className="navbar-link-container navbar-dropdown-item">
                  <i className="material-icons navbar-icon">dashboard</i>
                  <Link to="/user_management/dashboard_groups" className={`${getLinkClass('/user_management/dashboard_groups')} js-menu-close menu-close`}>Dashboard Groups</Link>
                </div>
              )}
            </div>
          )}
          {uralarm[0] === '1' && (
            <div className="navbar-dropdown-container">
              <div className="navbar-dropdown-header">
                <i className="material-icons navbar-icon">alarm</i>
                <Link to="/alarms" className={`${getLinkClass('/alarms')} js-menu-close menu-close`}>Alarms</Link>
                {(uralarm[1] === '1' || uralarm[2] === '1' || uralarm[3] === '1') && (
                  <i className="material-icons navbar-dropdown-icon">expand_more</i>
                )}
              </div>
              {uralarm[1] === '1' && (
                <div className="navbar-link-container navbar-dropdown-item">
                  <i className="material-icons navbar-icon">add_circle_outline</i>
                  <Link to="/alarms/create" className={`${getLinkClass('/alarms/create')} js-menu-close menu-close`}>Create</Link>
                </div>
              )}
              {uralarm[2] === '1' && (
                <div className="navbar-link-container navbar-dropdown-item">
                  <i className="material-icons navbar-icon">edit</i>
                  <Link to="/alarms/edit" className={`${getLinkClass('/alarms/edit')} js-menu-close menu-close`}>Edit</Link>
                </div>
              )}
              {uralarm[3] === '1' && (
                <div className="navbar-link-container navbar-dropdown-item">
                  <i className="material-icons navbar-icon">delete</i>
                  <Link to="/alarms/delete" className={`${getLinkClass('/alarms/delete')} js-menu-close menu-close`}>Delete</Link>
                </div>
              )}
            </div>
          )}
          {urreport[0] === '1' && (
            <div className="navbar-link-container">
              <i className="material-icons navbar-icon">description</i>
              <Link to="/reports" className={`${getLinkClass('/reports')} js-menu-close menu-close`}>Reports</Link>
            </div>
          )}
          {urview[0] === '1' && (
            <div className="navbar-dropdown-container">
              <div className="navbar-dropdown-header">
                <i className="material-icons navbar-icon">library_books</i>
                <Link to="/views" className={`${getLinkClass('/views')} js-menu-close menu-close`}>Views</Link>
                {(urview[1] === '1' || urview[2] === '1' || urview[3] === '1') && (
                  <i className="material-icons navbar-dropdown-icon">expand_more</i>
                )}
              </div>
              {urview[1] === '1' && (
                <div className="navbar-link-container navbar-dropdown-item">
                  <i className="material-icons navbar-icon">add_circle_outline</i>
                  <Link to="/views/create" className={`${getLinkClass('/views/create')} js-menu-close menu-close`}>Create</Link>
                </div>
              )}
              {urview[2] === '1' && (
                <div className="navbar-link-container navbar-dropdown-item">
                  <i className="material-icons navbar-icon">edit</i>
                  <Link to="/views/edit" className={`${getLinkClass('/views/edit')} js-menu-close menu-close`}>Edit</Link>
                </div>
              )}
              {urview[3] === '1' && (
                <div className="navbar-link-container navbar-dropdown-item">
                  <i className="material-icons navbar-icon">delete</i>
                  <Link to="/views/delete" className={`${getLinkClass('/views/delete')} js-menu-close menu-close`}>Delete</Link>
                </div>
              )}
            </div>
          )}
          {(ursource[0] === '1' || ursource[1] === '1' || ursource[2] === '1' || ursource[3] === '1') && (
            <div className="navbar-link-container">
              <i className="material-icons navbar-icon">settings</i>
              <Link to="/sensor_settings" className={`${getLinkClass('/sensor_settings')} js-menu-close menu-close`}>Settings</Link>
            </div>
          )}
          {(urrole[1] === '1' || urrole[2] === '1' || urrole[3] === '1' || urrole[4] === '1') && (
            <div className="navbar-dropdown-container">
              <div className="navbar-dropdown-header">
                <i className="material-icons navbar-icon">supervisor_account</i>
                <span className={`${getLinkClass('/permissions')} js-menu-close menu-close`}>Roles</span>
                {(urrole[1] === '1' || urrole[2] === '1' || urrole[3] === '1' || urrole[4] === '1') && (
                  <i className="material-icons navbar-dropdown-icon">expand_more</i>
                )}
              </div>
              {urrole[1] === '1' && (
                <div className="navbar-link-container navbar-dropdown-item">
                  <i className="material-icons navbar-icon">add_circle_outline</i>
                  <Link to="/permissions/create" className={`${getLinkClass('/permissions/create')} js-menu-close menu-close`}>Create Role</Link>
                </div>
              )}
              {urrole[2] === '1' && (
                <div className="navbar-link-container navbar-dropdown-item">
                  <i className="material-icons navbar-icon">edit</i>
                  <Link to="/permissions/edit" className={`${getLinkClass('/permissions/edit')} js-menu-close menu-close`}>Edit Role</Link>
                </div>
              )}
              {urrole[3] === '1' && (
                <div className="navbar-link-container navbar-dropdown-item">
                  <i className="material-icons navbar-icon">delete</i>
                  <Link to="/permissions/delete" className={`${getLinkClass('/permissions/delete')} js-menu-close menu-close`}>Delete Role</Link>
                </div>
              )}
              {urrole[4] === '1' && (
                <div className="navbar-link-container navbar-dropdown-item">
                  <i className="material-icons navbar-icon">assignment</i>
                  <Link to="/permissions/assign" className={`${getLinkClass('/permissions/assign')} js-menu-close menu-close`}>Assign Role</Link>
                </div>
              )}
            </div>
          )}
          {userstatus === 'superuser' && (
            <div className="navbar-link-container">
              <i className="material-icons navbar-icon">verified_user</i>
              <Link to="/superuser" className={`${getLinkClass('/superuser')} js-menu-close menu-close`}>SuperUser</Link>
            </div>
          )}
          {uruser[1] === '1' && (
            <div className="navbar-link-container">
              <i className="material-icons navbar-icon">share</i>
              <Link to="/invite-user" className={`${getLinkClass('/invite-user')} js-menu-close menu-close`}>Invite user</Link>
            </div>
          )}
          <div className="navbar-link-container navbar-last-item">
            <i className="material-icons navbar-icon">exit_to_app</i>
            <Link to="/logout" className={`${getLinkClass('/logout')} js-menu-close menu-close`}>Logout</Link>
          </div>
        </div>
      </div>
    </nav>
  );
});

export default Navbar;